// @flow

import { curry, lensPath, set, view } from "ramda";

import { type CurriedFn2 } from "@quantum/utils";

type TabsID = string;
type TabID = string;

export type SetActiveTabAction = {|
  type: "quantum/ui@SET_ACTIVE_TAB",
  payload: TabID,
  meta: TabsID,
|};
export const setActiveTab = (
  tabsId: TabsID,
  tabId: TabID
): SetActiveTabAction => ({
  type: "quantum/ui@SET_ACTIVE_TAB",
  payload: tabId,
  meta: tabsId,
});

type State = {
  "quantum/ui@tabs": number,
};

type TabAction = SetActiveTabAction;

const tabsLens = (tabsId: TabsID) => lensPath(["quantum/ui@tabs", tabsId]);

export const tabsReducer = (state: State, action: TabAction): State => {
  switch (action.type) {
    case "quantum/ui@SET_ACTIVE_TAB": {
      const { meta: tabsId, payload: activeTab } = action;
      return set(tabsLens(tabsId), activeTab, state);
    }

    default:
      return state;
  }
};

export const activeTab: CurriedFn2<
  TabsID,
  State,
  TabID
> = curry((tabsId, state) => view(tabsLens(tabsId), state));
